/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Admin_Subscription_Rights_Quota_HelpInputs */

const fr_admin_subscription_rights_quota_help = /** @type {(inputs: Admin_Subscription_Rights_Quota_HelpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Laisser vide pour appliquer la valeur du palier (${i?.value}). À corriger seulement pour un geste commercial ou un cas particulier.`)
};

/**

* @param {Admin_Subscription_Rights_Quota_HelpInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const admin_subscription_rights_quota_help = /** @type {((inputs: Admin_Subscription_Rights_Quota_HelpInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscription_Rights_Quota_HelpInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_admin_subscription_rights_quota_help(inputs)
});